import { BaseController } from '../../../../common/base/controller';

class TicketSummaryController extends BaseController {
  constructor(controllerService, ticketReaderFactory) {
    'ngInject';
    super({ controllerService, ticketReaderFactory });
  }

  $onInit() {
  }
}

export default TicketSummaryController;
